import React, { Component } from "react";
import { Button } from "reactstrap";
import style from "./Setting.module.css";
import Dropdown from "../../utils/Dropdown.json";
import api from "../../utils/Api";
import { connect } from "react-redux";
import { fetchDropdownList } from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";

export class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maximumUpload: "",
      selectedOption: "add",
      picklist: [],
      existList: [],
      isPickListLoaded: false,
      newOption: "",
      editOption: "",
      picklistName: "",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      error: "",
      removeOption: "",
      error: "",
      picklistError: "",
      newOptionError: "",
      editPicklistError: "",
      editNewOptionError: "",
      removePicklisterror: "",
      removeOptionError: "",
      editChoosePicklistError: "",
    };
  }

  componentDidMount = async () => {
    document.title = 'Settings - TechToMedix';
    // Calling fetch picklist options method
    await this.getPicklist();
  };

  // fetching picklist options
  getPicklist = async () => {
    this.setState({
      isPickListLoaded: false,
    });
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get("setting/fetch", {
        headers: headers,
      });
      this.setState({
        maximumUpload: response.data.data.setting.max_upload,
        picklist: response.data.data.picklist,
      });
      setTimeout(() => {
        this.setState({
          isPickListLoaded: true,
        });
      }, 2000);
    } catch (error) {
      console.log("Error", error);
    }
  };

  handleOptionChange = (changeEvent) => {
    this.setState({
      selectedOption: changeEvent.target.value,
      error: "",
      removeOption: "",
      picklistName: "",
      picklistError: "",
      newOptionError: "",

      editPicklistError: "",
      editNewOptionError: "",
      editChoosePicklistError: "",

      removePicklisterror: "",
      removeOptionError: "",
    });
  };

  handleChange = (event) => {
    this.setState({
      maximumUpload: event.target.value,
    });
  };
  handleAddOptionChange = (event) => {
    this.setState({
      newOption: event.target.value,
      picklistError: "",
      newOptionError: "",

      editPicklistError: "",
      editNewOptionError: "",
      editChoosePicklistError: "",

      removePicklisterror: "",
      removeOptionError: "",
      editnewOptionError: "",
      newOptionError: "",
    });
  };

  handlePicklistChange = (event) => {
    let removeOptionLabel =
      event.target.options[event.target.selectedIndex].text;
    this.setState({
      editOption: event.target.value,
      removeOption: event.target.value ? removeOptionLabel : "",
      editChoosePicklistError: "",
      removeOptionError:""
    });
  };

  selectChange = (event) => {
    let val = event.target.value;
    this.setState({
      picklistName: val,
      existList: this.props.dropdownListData.dropdownList[val],

      picklistError: "",
      newOptionError: "",
      editPicklistError: "",
      editNewOptionError: "",
      removePicklisterror: "",
      removeOptionError: "",
      editChoosePicklistError: "",
    });
  };

  // handleBlurChange = () => {
  //   if (this.state.newOption === undefined || this.state.newOption === "") {
  //     this.setState({
  //       error: "Option name  is required",
  //     });
  //   } else {
  //     this.setState({
  //       error: "",
  //     });
  //   }
  // };

  onSubmit = async () => {
     this.setState({
            errorMessage: "",
          });
    // Validations
    if (
      (this.state.selectedOption === "add" && this.state.picklistName === "") ||
      (this.state.selectedOption === "edit" &&
        this.state.picklistName === "") ||
      (this.state.selectedOption === "remove" && this.state.picklistName === "")
    ) {
      this.setState({
        picklistError: "Choose picklist is required field",
        editPicklistError: "Choose picklist is required field",
        removePicklisterror: "Choose picklist is required field",
      });
    } else if (
      (this.state.selectedOption === "add" && this.state.newOption === "") ||
      (this.state.selectedOption === "edit" && this.state.newOption === "") ||
      (this.state.selectedOption === "remove" && this.state.removeOption === "")
    ) {
      this.setState({
        newOptionError: "Option name is required field",
        editnewOptionError: "Option name is required field",
        removeOptionError: "Remove option name is required field",
      });
    } else if (
      this.state.selectedOption === "edit" &&
      this.state.editOption === ""
    ) {
      this.setState({
        editChoosePicklistError: "Choose picklist is require field",
      });
    } else {
      const payload = {
        picklist_name: this.state.picklistName,
        picklist_option: this.state.newOption.trim(),
        action: this.state.selectedOption,
        max_upload: Number(this.state.maximumUpload),
      };

      // check add, edit or remove
      if (
        this.state.selectedOption === "edit" ||
        this.state.selectedOption === "remove"
      ) {
        payload.picklist_option_id = Number(this.state.editOption);
      }

      //headers
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };

      try {
        this.setState({
          isLoading: true,
        });

        const response = await api.post("setting/save", payload, {
          headers: headers,
        });

        // let message =
        //   this.state.selectedOption === "add"
        //     ? "Picklist option added successfully!"
        //     : this.state.selectedOption === "edit"
        //     ? " Picklist option updated successfully!"
        //     : "Picklist option removed successfully!";
        let message = "Settings saved successfully!";

        if (response.status === 200) {
          this.setState({
            isLoading: false,
            successMessage: message,
          });
          
          this.props.fetchDropdownList();
          setTimeout(() => {
            this.setState({
              successMessage: "",
              newOption: "",
              editOption: "",
              removeOption: "",
              picklistName: "",
              existList: "",
            });
            if (this.refs.editOptionName) {
              this.refs.editOptionName.value = "";
            }
           }, 2000);
        }
      } catch (error) {
        this.setState({
          isLoading: false,
          errorMessage: error.response.data.message,
        });
        // setTimeout(() => {
        //   this.setState({
        //     errorMessage: "",
        //   });
        // }, 2000);
      }
    }
  };

  render() {
    let referenceList;
    // getting picklist
    const picklistOptions = this.state.picklist.map((element, index) => (
      <option key={index} value={element.value}>
        {element.label}
      </option>
    ));
    if (this.state.existList && this.state.existList.length > 0) {
      const pickListKey = Object.keys(this.state.existList[0]);
      referenceList = this.state.existList.map((element, index) => (
        <option key={index} value={element[pickListKey[0]]}>
          {element[pickListKey[1]]}
        </option>
      ));
    }
    if (!this.state.isPickListLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} className="loader-image" />
        </div>
      );
    }

    return (
      <div className={style.settingMainWrapper}>
        <div className="row">
          <div className="col-lg-12">
            <h3>Picklist Customization</h3>
          </div>
          <div class="col-lg-12 intro-text">
            <p class="mb-4">
              These are the picklists across the systems. You can add, edit or
              remove the options from the selected picklists. Please confirm the
              changes you have made as the picklists options may have been
              selected by the users.
            </p>
          </div>
        </div>
        <form>
          {/* <div className="row">
            <div className="col-md-12">
              <div className={`row ${style.roleTopWrapper}`}>
                <div className="col-md-12 col-lg-12 col-xl-6">
                  <div className="form-group row">
                    <label
                      htmlFor="roleName"
                      className={`col-md-2.5 col-form-label ${style.roleLabel}`}
                    >
                      Maximum Upload Allowed :
                    </label>
                    <div className="col-md-6">
                      <input
                        type="text"
                        className={`form-control ${style.uploadLimitInput}`}
                        id="roleName"
                        onChange={this.handleChange}
                        value={this.state.maximumUpload}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr /> */}
          <div className="row">
            {/* <div className="col-md-12">
              <h4>Picklist Customization :</h4>
            </div> */}
            <div className="col-md-6">
              <p className={style.action}>
                Choose an action you want to perform on the picklist options :
              </p>
            </div>
            <div className="col-md-6">
              <div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="add"
                    name="setting"
                    value="add"
                    checked={this.state.selectedOption === "add"}
                    onChange={this.handleOptionChange}
                  />
                  <label className="custom-control-label" htmlFor="add">
                    Add
                  </label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="edit"
                    name="setting"
                    value="edit"
                    checked={this.state.selectedOption === "edit"}
                    onChange={this.handleOptionChange}
                  />
                  <label className="custom-control-label" htmlFor="edit">
                    Edit
                  </label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="remove"
                    name="setting"
                    value="remove"
                    checked={this.state.selectedOption === "remove"}
                    onChange={this.handleOptionChange}
                  />
                  <label className="custom-control-label" htmlFor="remove">
                    Remove
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className={style.picklistMainWrapper}>
            {/* {!this.state.isPickListLoaded && (
              <div className="align-center">
                    <img src={ttmLoader} className="loader-image" />
                </div>
            )} */}

            {this.state.selectedOption === "add" &&
              this.state.isPickListLoaded && (
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <h4>Add Picklist Options</h4>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-lg-5 col-xl-4">
                      <div className="form-group">
                        <label htmlFor="choose_picklist">
                          1. Choose Picklist :{" "}
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <select
                          className={`form-control ${
                            this.state.picklistError ? " is-invalid" : ""
                          } `}
                          id="choose_picklist"
                          name="choose_picklist"
                          onChange={this.selectChange}
                          value={
                            this.state.picklistName
                              ? this.state.picklistName
                              : ""
                          }
                        >
                          <option value="">Select picklist</option>
                          {picklistOptions}
                        </select>
                        <div className="error">{this.state.picklistError}</div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-5 col-xl-4">
                      <div className="form-group">
                        <label htmlFor="exist_list">
                          Existing List (For Reference) :
                        </label>
                        <select
                          className="form-control"
                          disabled={!this.state.picklistName}
                          id="exist_list"
                          name="exist_list"
                        >
                          <option value="">Picklist here</option>
                          {referenceList}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-lg-5 col-xl-4">
                      <div className="form-group">
                        <label htmlFor="option_name">
                          2. Add New Option Name :{" "}
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${style.addNewOption} ${
                            this.state.newOptionError ? " is-invalid" : ""
                          } `}
                          id="option_name"
                          onChange={this.handleAddOptionChange}
                          value={
                            this.state.newOption ? this.state.newOption : ""
                          }
                        />
                        <div className="error mt-1">
                          {this.state.newOptionError}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {this.state.selectedOption === "edit" &&
              this.state.isPickListLoaded && (
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <h4>Edit Picklist Options</h4>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-lg-5 col-xl-4">
                      <div className="form-group">
                        <label htmlFor="choose_picklist">
                          1. Choose Picklist :
                        </label>
                        <select
                          id="choose_picklist"
                          onChange={this.selectChange}
                          className={`form-control ${
                            this.state.editPicklistError ? " is-invalid" : ""
                          } `}
                          value={
                            this.state.picklistName
                              ? this.state.picklistName
                              : ""
                          }
                        >
                          <option value="">Select picklist</option>
                          {picklistOptions}
                        </select>
                        <div className="error">
                          {this.state.editPicklistError}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-5 col-xl-4">
                      <div className="form-group">
                        <label htmlFor="exist_list">
                          2. Choose picklist options to edit:
                        </label>
                        <select
                          id="exist_list"
                          name="exist_list"
                          disabled={!this.state.picklistName}
                          onChange={this.handlePicklistChange}
                          className={`form-control ${
                            this.state.editChoosePicklistError
                              ? " is-invalid"
                              : ""
                          } `}
                        >
                          <option value="">Picklist here</option>
                          {referenceList}
                        </select>
                        <div className="error">
                          {this.state.editChoosePicklistError}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-lg-5 col-xl-4">
                      <div className="form-group">
                        <div className="form-group">
                          <label htmlFor="option_name">
                            3. Edit Option Name :
                          </label>
                          <input
                            type="text"
                            className={`form-control ${style.addNewOption} ${
                              this.state.editnewOptionError ? " is-invalid" : ""
                            } `}
                            id="option_name"
                            onChange={this.handleAddOptionChange}
                            onBlur={this.handleBlurChange}
                            ref="editOptionName"
                          />
                          <div className="error mt-1">
                            {this.state.editnewOptionError}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {this.state.selectedOption === "remove" &&
              this.state.isPickListLoaded && (
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <h4>Delete Picklist Options</h4>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-lg-5 col-xl-4">
                      <div className="form-group">
                        <label htmlFor="choose_picklist">
                          1. Choose Picklist :
                        </label>
                        <select
                          className={`form-control ${
                            this.state.removePicklisterror ? " is-invalid" : ""
                          } `}
                          id="choose_picklist"
                          onChange={this.selectChange}
                          value={
                            this.state.picklistName
                              ? this.state.picklistName
                              : ""
                          }
                        >
                          <option value="">Select picklist</option>
                          {picklistOptions}
                        </select>
                        <div className="error mt-1">
                          {this.state.removePicklisterror}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-5 col-xl-4">
                      <div className="form-group">
                        <label htmlFor="exist_list">
                          2. Choose Picklist Option to remove :
                        </label>
                        <select
                          className={`form-control ${
                            this.state.removeOptionError ? " is-invalid" : ""
                          } `}
                          id="exist_list"
                          disabled={!this.state.picklistName}
                          name="exist_list"
                          onChange={this.handlePicklistChange}
                        >
                          <option value="">Picklist here</option>
                          {referenceList}
                        </select>
                        <div className="error mt-1">
                          {this.state.removeOptionError}
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.removeOption && (
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className={`form-group ${style.removeLabel}`}>
                          <label htmlFor="option_name">
                            {` Are you sure you want to delete  ${this.state.removeOption} ?`}
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
          </div>
          <div className={`row ${style.settingBtnWrapper}`}>
            <div
              className={`col-md-12 d-flex justify-content-center justify-content-sm-end ${style.btnWrapper}`}
            >
              <Button
                type="button"
                onClick={this.onSubmit}
                color="primary"
                className="mb-3"
              >
                Save
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {this.state.isLoading ? (
                <div className={style.loadingWrapper}>
                  <img src={ttmLoader} className={style.isLoading} />
                </div>
              ) : (
                <div>
                  {this.state.successMessage && (
                    <p className={style.successMessage}>
                      {this.state.successMessage}
                    </p>
                  )}
                  {this.state.errorMessage && (
                    <p className={style.errorMessage}>
                      {this.state.errorMessage}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

// export default Setting;

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Setting);
